import { handleWarning } from "@/vuex/modules/warning";
import { initialState } from "@/vuex/store";

const STATE_KEY = "jobStatusFinalWarning";
const RESULT_TYPE = "job-status-final-warning";
const RESULT = {
  continue: { type: RESULT_TYPE, result: "continue" },
  cancel: { type: RESULT_TYPE, result: "cancel" }
};

export default {
  async withJobStatusFinalWarning({ dispatch }, { action, record, context }) {
    return handleWarning({
      condition: record?.status?.final,
      warningDispatch: () =>
        dispatch("showJobStatusFinalWarning", { record, context }),
      action
    });
  },
  showJobStatusFinalWarning({ commit }, { record, context }) {
    return new Promise((resolve, reject) => {
      commit("replace", {
        state: STATE_KEY,
        data: {
          show: true,
          record,
          context,
          resolve,
          reject
        }
      });
    });
  },
  hideJobStatusFinalWarning({ commit }) {
    commit("replace", {
      state: STATE_KEY,
      data: initialState()[STATE_KEY]
    });
  },
  confirmJobStatusFinalWarning({ dispatch, state }) {
    state[STATE_KEY].resolve(RESULT.continue);
    dispatch("hideJobStatusFinalWarning");
  },
  cancelJobStatusFinalWarning({ dispatch, state }) {
    state[STATE_KEY].reject(RESULT.cancel);
    dispatch("hideJobStatusFinalWarning");
  }
};
